import clsx from 'clsx';
import includes from 'lodash/includes';

const button = (layoutClassName, variant, isDisabled, showOutline, size, state, isLoading) => {
    return clsx('whitespace-nowrap leading-none font-medium flex border items-center cursor-pointer', [
        includes(['primary', 'iconPrimary'], variant) && [
            !isDisabled && [
                !state && [
                    'text-white',
                    !isLoading && 'nj-border-brand nj-bg-brand hover:nj-bg-brand-hover hover:nj-button-border-hover',
                    isLoading && 'nj-bg-brand-hover nj-button-border-hover',
                ],
                state === 'danger' && [
                    'text-white',
                    !isLoading && 'border-red-500 bg-red-500 hover:bg-red-700 hover:border-red-700',
                    isLoading && 'bg-red-300 border-red-300',
                ],
                state === 'success' && [
                    'text-white',
                    !isLoading && 'border-green-500 bg-green-500 hover:bg-green-700 hover:border-green-700',
                    isLoading && 'bg-green-300 border-green-300',
                ],
            ],
            isDisabled && 'border-gray-200 nj-disabled-button-color text-gray-400',
        ],
        includes(['secondary', 'iconSecondary'], variant) && [
            'bg-white',
            !isDisabled && [
                !state && [
                    !isLoading &&
                        'nj-secondary-button hover:nj-secondary-button-border-hover hover:nj-text-button-hover hover:nj-secondary-button-opacity-hover',
                    isLoading && 'nj-button-border-hover nj-text-button-hover ',
                ],
                state === 'danger' && [
                    !isLoading && 'border-red-500 text-red-500 hover:text-red-700 hover:border-red-700',
                    isLoading && 'text-red-300 border-red-300',
                ],
                state === 'success' && [
                    !isLoading && 'border-green-500 text-green-500 hover:text-green-700 hover:border-green-700',
                    isLoading && 'text-green-300 border-green-300',
                ],
            ],
            isDisabled && 'border-gray-400 text-gray-400',
        ],
        includes(['social'], variant) && [
            'bg-white',
            !isDisabled && [
                !state && [
                    !isLoading && 'border-black text-black hover:bg-brand-50 ',
                    isLoading && 'border-black nj-text-black ',
                ],
            ],
            isDisabled && 'border-gray-400 text-gray-400',
        ],
        includes(['text', 'iconText'], variant) && [
            'border-transparent',
            !isDisabled && [
                !state && [!isLoading && 'nj-text-brand hover:nj-text-brand-hover ', isLoading && 'nj-text-brand-hover '],
                state === 'danger' && [!isLoading && 'text-red-500 hover:text-red-700', isLoading && 'text-red-300'],
                state === 'success' && [!isLoading && 'text-green-500 hover:text-green-700', isLoading && 'text-green-300'],
            ],
            isDisabled && 'text-gray-400',
        ],
        includes(['iconPrimary', 'iconSecondary'], variant) && 'rounded-full',
        includes(['primary', 'secondary', 'social'], variant) && 'nj-button-border-radius',
    ], size === 'xSmall' && [
        'text-caption1',
        includes(['iconPrimary', 'iconSecondary', 'iconText'], variant) && 'h-6 w-6',
        includes(['primary', 'secondary', 'text', 'social'], variant) && 'px-2 py-1.5 h-6',
    ], size === 'small' && [
        'text-paragraph',
        includes(['iconPrimary', 'iconSecondary', 'iconText'], variant) && 'h-8 w-8',
        includes(['primary', 'secondary', 'text', 'social'], variant) && 'px-3 py-1.5 h-8',
    ], size === 'medium' && [
        'text-body',
        includes(['iconPrimary', 'iconSecondary', 'iconText'], variant) && 'h-10 w-10',
        includes(['primary', 'secondary', 'text', 'social'], variant) && 'px-4 py-2.5 h-10',
    ], size === 'large' && [
        'text-body',
        includes(['iconPrimary', 'iconSecondary', 'iconText'], variant) && 'h-12 w-12',
        includes(['primary', 'secondary', 'text', 'social'], variant) && 'px-4 py-3 h-12',
    ], showOutline && '!outline !outline-3 !outline-brand-30', layoutClassName);
};
const container = 'flex w-full items-center justify-center cursor-pointer relative';
const childrenContainer = (hasChildren, isLoading, isIcon, variant) => clsx('flex relative w-full items-center justify-center cursor-pointer', hasChildren && !isIcon && 'gap-2', isLoading && 'invisible', variant === 'social' && 'font-bold');
const spinnerStyle = 'absolute';
var styles = {
    button,
    container,
    childrenContainer,
    spinnerStyle,
};

export { styles as default };
